// Models
import Model from './Model'

class SwiftMessage extends Model {
  get isIncoming () {
    return this.direction === MESSAGE_DIRECTIONS.INCOMING
  }

  get isServiceTypeFin () {
    return this.serviceType === SERVICE_TYPES.FIN
  }

  get messageTypeNumber () {
    return this.messageType.split('.')[1]
  }

  static get directionOptions () {
    return [
      { name: 'Incoming', value: MESSAGE_DIRECTIONS.INCOMING },
      { name: 'Outgoing', value: MESSAGE_DIRECTIONS.OUTGOING }
    ]
  }

  static get serviceTypeOptions () {
    return [
      { name: 'FIN', value: SERVICE_TYPES.FIN },
      { name: 'Interact', value: SERVICE_TYPES.INTER_ACT },
      { name: 'File act', value: SERVICE_TYPES.FILE_ACT }
    ]
  }

  static get serviceTypeFilterOptions () {
    return [
      { name: 'FIN', value: SERVICE_TYPES_FILTERS.FIN },
      { name: 'Interact', value: SERVICE_TYPES_FILTERS.INTER_ACT },
      { name: 'File act', value: SERVICE_TYPES_FILTERS.FILE_ACT }
    ]
  }

  get schema () {
    return [
      'id',
      'payload',
      'accountServiceInstitutionId',
      'createdAt',
      'direction',
      'messageCloudReference',
      'serviceType',
      'messageType',
      'operationId',
      'paymentId',
      'receiver',
      'rejectionCode',
      'rejectionReason',
      'sender',
      'senderReference',
      'statementAt',
      'transmissionStatus',
      'amount',
      'currency',
      'uetr',
      'updatedAt'
    ]
  }
}

export const MESSAGE_TYPES = [195, 196, 199, 202, 295, 296, 299, 995, 996, 999, '009']

export const SWIFT_MESSAGE_TYPES = {
  QUERIES: [195, 295, 995],
  ANSWERS: [196, 296, 996],
  BETWEEN_COMPANY_ACCOUNTS: [202, '009'],
  FREE_FORMAT: [199, 299, 999]
}

export const TRANSMISSION_STATUSES = {
  ACKED: 'ACKED',
  NACKED: 'NACKED',
  REJECTED: 'REJECTED'
}

export const MESSAGE_DIRECTIONS = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING'
}

export const SERVICE_TYPES_FILTERS = {
  FIN: 'FIN',
  INTER_ACT: 'INTER_ACT',
  FILE_ACT: 'FILE_ACT'
}

export const SERVICE_TYPES = {
  FIN: 'fin',
  INTER_ACT: 'interAct',
  FILE_ACT: 'fileAct'
}

export default SwiftMessage
